import { ReactElement } from 'react';

import { useTranslation } from 'modules/i18n';
import { IotaSnapIcon } from 'modules/icons';

import { WalletId } from '../../const';
import { ConnectButton } from '../ConnectButton';
import { translation } from './translation';

const INSTALL_WALLET_LINK =
  'https://snaps.metamask.io/snap/npm/liquidlink-lab/iota-metamask-snap/';

export function MetamaskSnapConnectButton(): ReactElement {
  const { t, keys } = useTranslation(translation);

  return (
    <ConnectButton
      icon={<IotaSnapIcon height={36} width={36} />}
      installWalletLink={INSTALL_WALLET_LINK}
      name={t(keys.iotaWallet)}
      walletId={WalletId.iotaSnap}
    />
  );
}
